import { createSlice } from "@reduxjs/toolkit";
import { listReviewsAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const listReviewSlice = createSlice({
  name: "listReview",
  initialState: data,
  reducers: {
    listReviewSlice(state) {
      state.isLoading = true;
    },
    listReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    listReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    listReviewSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const listReviewHandler = (review_id:any) => async (dispatch: any) => {
  try {
    dispatch(listReviewAction.listReviewSlice());
    const response: any = await listReviewsAPI(review_id);
    dispatch(listReviewAction.listReviewSliceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(listReviewAction.listReviewSliceFailure(e?.response?.data?.message));
    dispatch(listReviewAction.listReviewSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default listReviewSlice.reducer;
export const listReviewAction = listReviewSlice.actions;
